import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import taskTypeMessages from '@blade-sxp/task-management/lang/task-type';
import { getSearchQueryAttributesSearch, getTaskDetail, getIncidentRecords, getDeviceTree, } from '@blade-sxp/task-management/api/task-result/index';
import alertList from '@blade-sxp/task-management/pages/task-result/components/alert-list.vue';
import formFilter from '@blade-sxp/task-management/pages/task-result/components/form-filter.vue';
import DataResult from '@blade-sxp/data-mining/pages/companions/components/result/index.vue';
import DetailsPage from '@blade/common/pages/result-details/index.vue';
import moment from 'moment';
import { trackSpace, deleteImg, allTrack, cleanAll, deleteTrack } from '@blade-sxp/search-center/api/index';
import RoutePage from '@blade-sxp/search-center/pages/components/result/components/routePage.vue';
import { pageNum } from '@blade-sxp/search-center/interfaces/enum';
import { isEmpty } from 'lodash';
let default_1 = class extends Vue {
    taskType = '';
    taskId = '';
    timeFormat(time) {
        return moment(Number(time)).format('YYYY-MM-DD HH:mm:ss');
    }
    apiTaskDetailsType = '';
    apiTaskDetailsDeviceId = [];
    routeDialogVisible = false;
    allNum = 0;
    analysisHeader = 68;
    alertHeader = 117;
    pageSize = {
        size: 50,
        total: 0,
        page: 1,
    };
    form = {
        device: [],
        level: '',
        keyWord: '',
        similarity: 0,
        dateStart: '',
        dateEnd: '',
    };
    isOpenDetail = false;
    routeType = 'task';
    detailsIndex = 0;
    showPath = true;
    url = '';
    detailsData = [];
    tagList = []; // 吸顶后的数据
    imgList = [];
    // hover框轨迹数据
    selectedImg = [];
    isCheck = false;
    created() {
        this.taskId = this.$route.query.id || '';
        this.taskType = this.$route.query.type || 'ANALYSIS';
        this.getTaskDetail();
    }
    selectable() {
        this.isCheck = !this.isCheck;
        if (this.isCheck) {
            this.showPopover();
        }
    }
    changePageSize(page) {
        this.pageSize.page = page;
        this.getTaskDetail();
    }
    next() {
        if (this.detailsIndex + 1 === pageNum.PAGE_NUM) {
            return;
        }
        this.detailsIndex++;
        const detailsData = this.detailsData[this.detailsIndex];
        if (detailsData.checked) {
            this.showPath = false;
        }
        else {
            this.showPath = true;
        }
    }
    prev() {
        if (this.detailsIndex === 0) {
            return;
        }
        this.detailsIndex--;
        const detailsData = this.detailsData[this.detailsIndex];
        if (detailsData.checked) {
            this.showPath = false;
        }
        else {
            this.showPath = true;
        }
    }
    showBtn(btnPath) {
        this.showPath = btnPath;
    }
    showPopover() {
        allTrack()
            .then((res) => {
            if (res) {
                this.selectedImg = res;
                this.allNum = res.length;
            }
            else {
                this.selectedImg = [];
            }
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    // 清空全部轨迹
    clearAlltrack() {
        cleanAll()
            .then((res) => {
            if (res) {
                this.selectedImg = res;
                this.allNum = res.length;
            }
            else {
                this.selectedImg = [];
                this.allNum = 0;
            }
            this.imgList.forEach((item) => {
                item.checked = false;
            });
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    // 删除一个轨迹
    deleteImg(imageId) {
        deleteTrack(imageId)
            .then((res) => {
            this.showPopover();
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    // 选中/删除轨迹
    detailsChangeTrack(deviceVal, val, index) {
        this.changeChecked(val, deviceVal, index);
    }
    // 选中/删除轨迹
    changeTrack(val, deviceVal, index) {
        this.changeChecked(val, deviceVal, index);
    }
    openDetail(data, index) {
        this.isOpenDetail = true;
        this.detailsData = this.imgList;
        this.detailsIndex = index;
    }
    closeDetails() {
        this.isOpenDetail = false;
    }
    openTrack() {
        this.routeDialogVisible = true;
    }
    updateTagList(val) {
        this.tagList = [...val];
    }
    updateAlarmList(val) {
        this.form = { ...val };
        this.getTaskDetail();
    }
    getDeviceTreeFunc(list) {
        getDeviceTree()
            .then((res) => {
            if (res) {
                const terrArray = this.mapTree(res.trees) || [];
                this.apiTaskDetailsDeviceId = terrArray.filter((item) => list.some((ele) => ele === item.value));
            }
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    mapTree(originTree) {
        if (!isEmpty(originTree)) {
            let arr = [];
            const expanded = (datas) => {
                if (datas && datas.length > 0) {
                    datas.forEach((e) => {
                        if (e.children.length === 0) {
                            arr.push({
                                value: e.id,
                                label: e.name,
                            });
                        }
                        expanded(e.children);
                    });
                }
            };
            expanded(originTree);
            return arr;
        }
    }
    getDetail(data) {
        const list = [];
        data?.deviceTaskConfigs.forEach((element) => {
            list.push(element.deviceId);
        });
        this.getDeviceTreeFunc(list);
        const taskDetails = {
            deviceIdList: this.form.device && this.form.device.length > 0 ? this.form.device : list,
            featureList: [
                {
                    attributeMaps: {},
                    featureType: '',
                    taskType: data?.taskType,
                },
            ],
        };
        this.apiTaskDetailsType = data?.taskType;
        return taskDetails;
    }
    getTaskDetail() {
        getTaskDetail(Number(this.taskId))
            .then((res) => {
            if (res) {
                const taskDetails = this.getDetail(res);
                this.imgList = [];
                if (this.taskType === 'ANALYSIS') {
                    this.getSearchQueryAttributesSearch(taskDetails);
                }
                else if (this.taskType === 'ALERT') {
                    this.getIncidentRecords();
                }
            }
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    getSearchQueryAttributesSearch(val) {
        const params = {
            dateStart: this.form.dateStart,
            dateEnd: this.form.dateEnd,
            page: this.pageSize.page,
            size: this.pageSize.size,
            ...val,
        };
        getSearchQueryAttributesSearch({ ...params })
            .then((res) => {
            if (res) {
                res?.request?.featureList?.forEach((rItem) => {
                    res?.searchList?.forEach((sItem) => {
                        if (rItem?.featureType === sItem?.trackType) {
                            sItem?.list?.forEach((minItem, index) => {
                                let newObj = {
                                    portraitImage: minItem?.captureUrl,
                                    isDetailsType: false,
                                    detailsTaskType: this.apiTaskDetailsType,
                                    trackType: sItem.trackType,
                                    ...minItem,
                                };
                                this.imgList.push(newObj);
                            });
                            this.pageSize.size = sItem.size;
                            this.pageSize.total = sItem.total;
                        }
                    });
                });
            }
            else {
                this.pageSize.total = 0;
            }
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    getIncidentRecords() {
        getIncidentRecords({
            alertLevel: this.form.level,
            dateStart: this.form.dateStart,
            dateEnd: this.form.dateEnd,
            deviceIds: this.form.device,
            portraitName: this.form.keyWord,
            page: this.pageSize.page,
            size: this.pageSize.size,
            threshold: this.form.similarity ? (this.form.similarity / 100).toString() : '0',
            taskIds: [`${this.taskId}`],
            taskTypes: [`${this.apiTaskDetailsType}`],
        })
            .then((res) => {
            if (res) {
                res?.list?.forEach((item, index) => {
                    let newObj = {
                        isDetailsType: true,
                        detailsTaskType: this.apiTaskDetailsType,
                        trackType: item?.incidentType,
                        captureTime: this.timeFormat(item?.alertTime),
                        captureUrl: item?.faceAnnotation?.portraitCaptureImage,
                        similarity: item?.faceAnnotation?.value,
                        incidentExtraVO: {
                            eventRecordId: item.id,
                        },
                        checked: false,
                        ...item,
                    };
                    this.imgList.push(newObj);
                });
                this.pageSize.size = res.size;
                this.pageSize.total = res.total;
            }
            else {
                this.pageSize.total = 0;
            }
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    changeChecked(val, deviceVal, index) {
        const deviceData = deviceVal;
        this.detailsData[index] = deviceVal;
        if (!val) {
            const param = {
                imageExtraVO: deviceData.imageExtraVO,
                incidentExtraVO: deviceData.incidentExtraVO,
                trackType: deviceData.trackType,
            };
            deleteImg(param)
                .then((res) => {
                this.allNum = res;
                this.showPath = true;
            })
                .catch((err) => {
                this.$message({ message: err, type: 'error' });
            });
        }
        else {
            const param = {
                ...deviceData,
                trackType: deviceData.trackType,
                deviceType: deviceData.deviceType || '',
            };
            trackSpace(param)
                .then((res) => {
                this.allNum = res;
                this.showPath = false;
            })
                .catch((err) => {
                this.$message({ message: err, type: 'error' });
            });
        }
    }
};
default_1 = __decorate([
    Component({
        name: 'task-result',
        components: {
            'form-filter': formFilter,
            'data-result': DataResult,
            'alert-list': alertList,
            'details-page': DetailsPage,
            'route-page': RoutePage,
        },
        i18n: {
            messages: taskTypeMessages,
        },
    })
], default_1);
export default default_1;
